export default "__VITE_ASSET__BybLKCAI__"